module.exports = __webpack_public_path__ + "img/pinamar.0aee60ba.jpg";